import { Col, message, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import * as consultantReducer from "../Redux/Consultant/reducer";
import Feedback from "../Utilities/Feedback";
import { LoadingOutlined } from "@ant-design/icons";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form } from "formik-antd";
import { FormikSubmitButton, FormikTextArea } from "../FormItems";
import constants from "../Redux/constants";
import { StyledLink } from "../styled-components/components";
import { Helmet } from "react-helmet";

const initialValues = {
  comment: "",
};

const validationSchema = Yup.object().shape({
  comment: Yup.string().required("Please add a description"),
});

const ApplyJob = (props) => {
  const [appliedJob, setAppliedJob] = useState(false);
  const { fetchingJobs } = useSelector((state) => state.consultantStore);
  const { getJobDetail, jobId, checkApplyJob } = props;
  useEffect(() => {
    getJobDetail(jobId);
    checkApplyJob(jobId);
  }, [getJobDetail, jobId, checkApplyJob]);
  const { jobDetail, isJobApplied } = useSelector(
    (state) => state.consultantStore
  );
  const applyJob = async (details, actions) => {
    const responseStatusCode = await props.applyJob(jobId, details.comment);
    if (responseStatusCode === constants.status.success) {
      message.success("Applied for this job successfully", 3);
      setAppliedJob(true);
    }
  };
  return (
    <Col
      xs={{ span: 22 }}
      md={{ span: 14 }}
      lg={{ span: 12 }}
      xl={{ span: 8 }}
      xxl={{ span: 8 }}
      style={{ margin: "auto", marginTop: "2vh" }}
    >
      <Helmet title={`${jobDetail.title} | Unicon`}></Helmet>
      {fetchingJobs ? (
        <Feedback
          icon={<LoadingOutlined />}
          title="Fetching job  description"
        />
      ) : (
        <Formik
          initialValues={initialValues}
          validateOnMount
          validationSchema={validationSchema}
          onSubmit={(appliedDescription, actions) =>
            applyJob(appliedDescription, actions)
          }
        >
          {(formik) => (
            <Form>
              <Col>
                <Row>
                  <Typography.Title name="title" level={4}>
                    {jobDetail.title}
                  </Typography.Title>
                </Row>
                <Row>
                  <Typography.Paragraph>T24 Version:</Typography.Paragraph>
                  <Typography.Text strong>
                    {jobDetail.T24Release}
                  </Typography.Text>
                </Row>
                <Row>
                  <Typography.Paragraph>Type Requirement:</Typography.Paragraph>
                  <Typography.Text strong>
                    {jobDetail.typeRequirement}
                  </Typography.Text>
                </Row>
                <Row justify="space-between">
                  <Col>
                    <Row>
                      <Typography.Paragraph>Start Date:</Typography.Paragraph>
                      <Typography.Text strong>
                        {jobDetail.targetStartDate}
                      </Typography.Text>
                    </Row>
                  </Col>
                  <Col>
                    <Row>
                      <Typography.Paragraph>End Date:</Typography.Paragraph>
                      <Typography.Text strong>
                        {jobDetail.targetEndDate}
                      </Typography.Text>
                    </Row>
                  </Col>
                </Row>
                {jobDetail.attachments && jobDetail.attachments.length > 0 ? (
                  <Col>
                    <Row>
                      <Typography.Text strong>Attatchments:</Typography.Text>
                    </Row>
                    <Col>
                      {jobDetail.attachments.map((file, i) => (
                        <Col>
                          {file.fileUrl ? (
                            <StyledLink href={file.fileUrl}>
                              {i + 1}.{file.fileName}
                            </StyledLink>
                          ) : null}
                        </Col>
                      ))}
                    </Col>
                  </Col>
                ) : null}

                {isJobApplied ? (
                  <Typography.Text strong>
                    You have already Applied for this job
                  </Typography.Text>
                ) : (
                  <Col>
                    {appliedJob ? (
                      <Typography.Text strong>
                        You have sucessfully Applied for this job.
                      </Typography.Text>
                    ) : (
                      <Col xs={{ span: 24 }}>
                        <Row>
                          <Col xs={{ span: 24 }}>
                            <FormikTextArea
                              id="additionalComments"
                              name="comment"
                              placeholder="Describe your experience..."
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={{ span: 24 }}>
                            <FormikSubmitButton
                              id="submit-applyJob"
                              name="Apply Job"
                              disabled={!formik.isValid}
                            />
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Col>
                )}
              </Col>
            </Form>
          )}
        </Formik>
      )}
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getJobDetail: (jobId) => dispatch(consultantReducer.getJobDetail(jobId)),
    applyJob: (jobId, comment) =>
      dispatch(consultantReducer.applyJob(jobId, comment)),
    checkApplyJob: (jobId) => dispatch(consultantReducer.checkApplyJob(jobId)),
  };
};

export default connect(null, mapDispatchToProps)(ApplyJob);
